import moment from "moment";
import { LabelText } from "../Utils/Input";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";

export const OrderDetailsInViewCancel = ({
  isView,
  isCancel,
  orderDataById,
  orderID,
  status,
  currentDate,
}) => {
  return (
    <div>
      <h6 className="fs-16 fw-semibold mb-3">Order Details</h6>
      <Row>
        <Col xl={12} className="mb-3">
          <LabelText className="fs-14 fw-bold" displayText={"Order Number"} />
          <p className="rv-label-muted my-2 fs-14">
            {isView || isCancel ? orderDataById.id : orderID}
          </p>
        </Col>
        <Col xs={12} className="mb-3">
          <LabelText className="fs-14 fw-bold" displayText={"Order status"} />
          <p class="fw-bold my-2 fs-14">
            <span
              className={
                isView || isCancel
                  ? orderDataById.state === "pending"
                    ? "order-status-pending text-black py-1 px-2 rounded-1 d-inline-flex align-items-center"
                    : orderDataById.state === "acknowledged"
                    ? "order-status-acknowledged text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                    : orderDataById.state === "failed"
                    ? "order-status-failed text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                    : orderDataById.state === "cancelled"
                    ? "order-status-cancelled text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                    : orderDataById.state === "completed"
                    ? "order-status-completed text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                    : ""
                  : status === "Pending"
                  ? "order-status-pending text-black py-1 px-2 rounded-1 d-inline-flex align-items-center"
                  : status === "Acknowledged"
                  ? "order-status-acknowledged text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                  : status === "Failed"
                  ? "order-status-failed text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                  : status === "Cancelled"
                  ? "order-status-cancelled text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                  : status === "Completed"
                  ? "order-status-completed text-white py-1 px-2 rounded-1 d-inline-flex align-items-center"
                  : ""
              }
            >
              { orderDataById?.state === "pending" || status === "Pending" ? (
                <i>
                  <HourglassEmptyIcon fontSize="small" />
                </i>
              ) : orderDataById?.state === "acknowledged" || status === "Acknowledged" ? (
                <i>
                  <HandshakeIcon  fontSize="small" />
                </i>
              ) : (
                <i
                  className={
                    orderDataById?.state === "failed" || status === "Failed"
                      ? "ri-close-circle-fill pe-1"
                      : orderDataById?.state === "cancelled" ||
                        status === "Cancelled"
                      ? "ri-close-circle-fill pe-1"
                      : orderDataById?.state === "completed" ||
                        status === "Completed"
                      ? "ri-checkbox-circle-line pe-1"
                      : ""
                  }
                ></i>
              )}

              <span className="px-2">
                {isView || isCancel
                  ? ` ${
                      orderDataById.state === "pending"
                        ? "Pending"
                        : orderDataById.state === "acknowledged"
                        ? "Acknowledged"
                        : orderDataById.state === "failed"
                        ? "Failed"
                        : orderDataById.state === "cancelled"
                        ? "Cancelled"
                        : orderDataById.state === "completed"
                        ? "Completed"
                        : ""
                    }`
                  : ` ${status}`}
              </span>
            </span>
          </p>
        </Col>
        <Col xl={12} className="mb-3">
          <LabelText className="fs-14 fw-bold" displayText={"Created Date"} />
          <p className="rv-label-muted my-2 fs-14">
            {isView || isCancel
              ? moment(orderDataById.creationDate).format("DD MMM YYYY")
              : currentDate.format("DD MMM YYYY")}
          </p>
        </Col>

      </Row>
    </div>
  );
};
